/**
 * Mock 模块：heart_voyage_stage_remind
 * @see specs/api/heart_voyage_stage_remind.md
 */
import type {HeartVoyageStageRemindData} from '../types'

/** @see specs/api/heart_voyage_stage_remind.md */
export const HeartVoyageStageRemindMock: HeartVoyageStageRemindData = {
  err_msg: '',
}
